module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_m_albino.0a2a8f13.png";